import React from 'react';
import TextTheme from "components/General/Text/TextTheme";
import CustomSelect from "components/General/Form/CustomSelect";
import * as CONSTANT from "constants/text"
import GroupsProjectInviteCard from "components/Project/StartProject/Step_3/GroupProjectInviteCard";


class GroupProjectInvite extends React.Component {
    constructor(props) {
        super(props);
        //constuct state
        this.state = {
            group: "",
            group_obj: "",
        };

        //function binding
        this.handleDataChange = this.handleDataChange.bind(this);
        this.onRemoveInviteClick = this.onRemoveInviteClick.bind(this);
    }

    /**
     * handler for removing a group invite
     */
    onRemoveInviteClick() {
        //clear state
        this.setState({
            group_obj: "",
            group: "",
        });

        //update state of StartProjectStepThree
        this.props.caller.setState({selected_group: ""});
    }

    /*
    * On data change.
    */
    handleDataChange(e) {
        //set the value of the select field
        this.setState({ [e.target.name]: e.target.value });

        // now set the group object
        this.props.groups.forEach(elem => {
            if (e.target.value === elem.group.name) {
                let group_obj= {
                    name: elem.group.name,
                    id: elem.group.id,
                    group_pic: elem.group.group_pic,
                    role: elem.role,
                    date_joined: elem.date_joined,
                }
                //set the selected group object
                this.setState({
                    group_obj: group_obj
                })
                //update state of StartProjectStepThree
                this.props.caller.setState({selected_group:group_obj });

                return;
            }
        });

    }

    /**
     * Render the component
     */
    render() {
        return (
            <div>
                {/* If this user has a group that they own, display the entire component */}
                {this.props.groups ?
                    (
                        <div>
                            <br />
                            <hr />
                            <div style={{ marginTop: "20px" }}>
                                <div>
                                    <TextTheme
                                        message="2. Send Invites to your group."
                                        className="text_medium text_black"
                                    />
                                </div>

                                <div style={{ width: "30%" }}>
                                    <br />
                                    <TextTheme
                                        message={CONSTANT.SELECT_A_GROUP}
                                        className="text_small text_black"
                                    />
                                    <CustomSelect
                                        name={"group"}
                                        value={this.state.group}
                                        placeholder={CONSTANT.GROUPS}
                                        handleChange={this.handleDataChange}
                                        options={this.props.groupNames}
                                    />
                                </div>
                                <br />
                                {this.state.group_obj ? (
                                    <div>
                                        <div style={{ width: "31%" }}>
                                            <GroupsProjectInviteCard
                                                onImageClick={() => (window.open(
                                                    '/groups/'
                                                    + CONSTANT.VIEW
                                                    + '/'
                                                    + this.state.group_obj.id
                                                    + '/'
                                                    + this.state.group_obj.name, '_blank'))}
                                                key={this.state.group_obj.id}
                                                imageSrc={this.state.group_obj.group_pic}
                                                imageId={this.state.group_obj.id}
                                                imageName={this.state.group_obj.name}
                                                buttonDisabled={true}
                                                type={CONSTANT.GROUPS}
                                                groupName={this.state.group_obj.name}
                                                groupID={this.state.group_obj.id}
                                                onRemoveInvite={this.onRemoveInviteClick}
                                            />
                                        </div>
                                        <br />
                                        <TextTheme
                                            message={CONSTANT.SELECTED_GROUP
                                                + this.state.group_obj.name
                                                + CONSTANT.SELECTED_GROUP2}
                                            className="text_small text_black"
                                        />
                                    </div>
                                ) : (null)}
                            </div>
                        </div>
                    ) : (null)
                }
            </div>
        );
    }

}

export default GroupProjectInvite


